import React from "react";
import { Dot } from 'lucide-react';
import insight1 from "../assets/img/insight-1.svg";
import insight2 from "../assets/img/insight-2.svg";
import insight3 from "../assets/img/insight-3.svg";
import { ArrowRight, CalendarCheck } from 'lucide-react';
import { Link } from "react-router-dom";

const resources = [
  {
    title: "Industry Trends",
    desc: "How to Create the Perfect Survey for Your Industry",
    img: insight1,
  },
  {
    title: "Latest News",
    desc: "Maximizing Rewards: Tips to Earn More Points Faster",
    img: insight2,
  },
  {
    title: "Opinion Articles", 
    desc: "Top 5 Emerging Trends in Market Research",
    img: insight3,
  },
  
];

const CardContainer = () => {
  return (
    <section className="ptb60px pb-0 px-3">
      <div className="container mx-auto">

        {/* Heading */}
        <div
          className="headingbox text-center mb-5 w-100 mx-auto"
          data-aos="fade-up"
        >
          <h2 className="font-weight-bold mb-2 headinglg">
            <span className="uline">Insights and Resources</span>
          </h2>

          <p className="customtextgray">
            Stay updated with the latest industry trends, survey tips, and Imp.com news.
          </p>
        </div>

        {/* Grid */}
        <div className="row mt-3" data-aos="fade-up">
          {resources.map((card, i) => (
            <div
              key={i}
              className="col-12 col-md-4 mb-4 mt-3"
            >

              <div className="d-flex flex-column h-100 card-hover">

                {/* Image */}
                <div className="w-100 overflow-hidden rounded-10 custom-img">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-100 h-100 object-fit-cover"
                    loading="lazy"
                  />
                </div>

                {/* Content */}
                <div className="py-2 d-flex flex-column flex-grow-1">

                  <div className="d-flex align-items-center">
                    <Dot size={32} className="textred mlminus" />
                    <p className="textred small mb-0">
                      {card.title}
                    </p>
                  </div>

                  <div className="headingbox">
                    <h3 className="mb-2 custom-h3">
                      <span className="uline">{card.desc}</span>
                    </h3>
                  </div>

                  <div className="text-muted small">
                    <span>1 day ago / 5 min read</span>
                  </div>

                </div>
              
              </div>

            </div>
          ))}
        </div>

        {/* Button */}
        <div className="mt-4 d-flex align-items-center justify-content-center" data-aos="zoom-in-up">
          <Link
            to="/"
            className="cursor-target mt-4 fw-semibold text-white px-5 py-3 bgred rounded-8 hover:tw-bg-[#333] tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-scale-105"
          >
            Explore More
          </Link>
        </div>

      </div>
    </section>
  );
};

export default CardContainer;
